<template>
  <v-container fluid tag="section" class="cyber-moments">
    <v-row>
      <v-col cols="12" md="4">
        <base-material-card color="#018C74" icon="mdi-camera-plus" class="glass-card">
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-text">ARSIP MOMEN</div>
            <div class="subtitle-2 secondary-text">
              Enkripsi Visual & Dokumentasi Digital
            </div>
          </template>

          <v-form ref="form" class="mt-4">
            <v-text-field
              v-model="editedItem.judul_momen"
              label="Judul Momen / Event"
              outlined
              dense
              color="#018C74"
              prepend-inner-icon="mdi-label-outline"
            />

            <v-textarea
              v-model="editedItem.deskripsi"
              label="Deskripsi Singkat"
              outlined
              dense
              rows="3"
              color="#018C74"
              prepend-inner-icon="mdi-text-box-outline"
            />

            <v-text-field
              v-model="editedItem.tanggal_ambil"
              label="Timestamp Pengambilan"
              type="date"
              outlined
              dense
              color="#CFA22D"
              prepend-inner-icon="mdi-calendar-clock"
              class="cyber-input-highlight"
            />

            <v-file-input
              v-model="files"
              label="Unggah Multi-Media"
              multiple
              outlined
              dense
              prepend-inner-icon="mdi-image-multiple-outline"
              prepend-icon=""
              accept="image/*"
              counter
              show-size
              color="#018C74"
              class="cyber-file-input"
            />

            <v-btn
              color="#CFA22D"
              block
              large
              :loading="loading"
              @click="save"
              class="cyber-save-btn mt-2"
            >
              <v-icon left>mdi-cloud-upload-outline</v-icon> UNGGAH KE SERVER
            </v-btn>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="8">
        <v-card class="glass-card mb-6 pa-2 border-primary" elevation="0">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify-scan"
            label="Cari Momen..."
            single-line
            hide-details
            rounded
            color="#CFA22D"
            class="cyber-search"
          ></v-text-field>

          <v-chip-group
            v-model="filterAktif"
            mandatory
            active-class="momen-chip-active"
            class="px-2 pt-2"
          >
            <v-chip value="semua" small outlined>Semua ({{ momenList.length }})</v-chip>
            <v-chip value="aktif" small outlined>Tampil ({{ jumlahAktif }})</v-chip>
            <v-chip value="nonaktif" small outlined
              >Disembunyikan ({{ jumlahNonaktif }})</v-chip
            >
          </v-chip-group>
        </v-card>

        <v-row>
          <v-col v-for="momen in filteredMomen" :key="momen.id" cols="12" sm="6" lg="4">
            <v-card
              class="cyber-card rounded-lg overflow-hidden glass-card h-100"
              :class="{ 'momen-off': !aktif(momen) }"
            >
              <v-carousel
                v-if="splitFoto(momen.list_foto).length > 0"
                height="200"
                hide-delimiter-background
                show-arrows-on-hover
                delimiter-icon="mdi-circle-medium"
                class="cyber-carousel"
              >
                <v-carousel-item
                  v-for="(img, i) in splitFoto(momen.list_foto)"
                  :key="i"
                  :src="`https://berkah.bondowosokab.go.id:5500/uploads/${img}`"
                  reverse-transition="fade-transition"
                  transition="fade-transition"
                >
                  <div class="img-overlay"></div>
                </v-carousel-item>
              </v-carousel>

              <v-img
                v-else
                height="200"
                src="https://via.placeholder.com/400x200?text=No+Data+Signal"
                class="grayscale"
              />

              <v-card-text class="pa-4">
                <div class="d-flex justify-space-between align-start mb-2">
                  <span class="white--text font-weight-bold text-h6 cyber-title">{{
                    momen.judul_momen
                  }}</span>
                  <v-chip x-small color="#018C74" class="glow-chip"
                    >{{ splitFoto(momen.list_foto).length }} UNIT</v-chip
                  >
                </div>

                <div class="mb-2">
                  <v-chip
                    v-if="!aktif(momen)"
                    x-small
                    label
                    color="#FF5252"
                    class="white--text mr-1"
                  >
                    <v-icon left x-small>mdi-eye-off-outline</v-icon>DISEMBUNYIKAN
                  </v-chip>
                  <v-chip
                    v-else-if="diLuarJendela(momen)"
                    x-small
                    label
                    color="#CFA22D"
                    class="white--text mr-1"
                  >
                    <v-icon left x-small>mdi-clock-alert-outline</v-icon>LEWAT 6 BULAN
                  </v-chip>
                  <v-chip v-else x-small label outlined color="#018C74" class="mr-1">
                    <v-icon left x-small>mdi-eye-outline</v-icon>TAMPIL DI DEPAN
                  </v-chip>
                </div>

                <div class="caption secondary-text mb-3">
                  <v-icon x-small color="#CFA22D">mdi-database-clock</v-icon> LOG:
                  {{ formatDate(momen.tanggal_ambil) }}
                </div>

                <p class="cyber-desc mb-0">
                  {{ momen.deskripsi || "Sistem: Tidak ada deskripsi tambahan." }}
                </p>
              </v-card-text>

              <v-divider class="mx-4 opacity-2"></v-divider>

              <v-card-actions class="pa-3">
                <v-switch
                  :input-value="aktif(momen)"
                  :loading="busyId === momen.id"
                  :disabled="busyId === momen.id"
                  :label="aktif(momen) ? 'Tampil di depan' : 'Disembunyikan'"
                  color="#018C74"
                  inset
                  dense
                  hide-details
                  class="mt-0 pt-0 momen-switch"
                  @change="toggleAktif(momen, $event)"
                />
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  color="#FF5252"
                  @click="deleteItem(momen)"
                  class="glow-hover-red"
                >
                  <v-icon>mdi-delete-variant</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-alert
          v-if="filteredMomen.length === 0"
          border="left"
          colored-border
          color="#CFA22D"
          class="glass-card mt-4"
        >
          DATA PENCARIAN NIHIL: Silakan periksa kembali parameter filter Anda.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    loading: false,
    search: "",
    filterAktif: "semua",
    busyId: null,
    files: [],
    momenList: [],
    editedItem: {
      judul_momen: "",
      deskripsi: "",
      tanggal_ambil: new Date().toISOString().substr(0, 10),
    },
  }),

  computed: {
    filteredMomen() {
      return this.momenList.filter((item) => {
        const cocokCari = (item.judul_momen || "")
          .toLowerCase()
          .includes(this.search.toLowerCase());
        const cocokStatus =
          this.filterAktif === "semua" ||
          (this.filterAktif === "aktif" ? this.aktif(item) : !this.aktif(item));
        return cocokCari && cocokStatus;
      });
    },
    jumlahAktif() {
      return this.momenList.filter((m) => this.aktif(m)).length;
    },
    jumlahNonaktif() {
      return this.momenList.length - this.jumlahAktif;
    },
  },

  mounted() {
    this.fetchMomen();
  },

  methods: {
    async fetchMomen() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/momen`);
        if (res.data && res.data.response && res.data.response.data) {
          this.momenList = res.data.response.data;
        } else {
          this.momenList = res.data.data || [];
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    // is_active: 1 = tampil, 0 = disembunyikan (kolom belum ada/null dianggap tampil)
    aktif(m) {
      return (
        m.is_active === undefined || m.is_active === null || Number(m.is_active) === 1
      );
    },

    // Halaman depan hanya menampilkan momen 6 bulan terakhir (berdasar tanggal_ambil)
    diLuarJendela(m) {
      if (!m.tanggal_ambil) return false;
      const batas = new Date();
      batas.setMonth(batas.getMonth() - 6);
      batas.setHours(0, 0, 0, 0);
      return new Date(m.tanggal_ambil) < batas;
    },

    async toggleAktif(momen, nilai) {
      const baru = nilai ? 1 : 0;
      const lama = momen.is_active;
      this.busyId = momen.id;
      this.$set(momen, "is_active", baru); // langsung terlihat, dibatalkan kalau gagal
      try {
        await axios.put(`${BASE_URL}/momen/${momen.id}/active`, { is_active: baru });
      } catch (e) {
        this.$set(momen, "is_active", lama === undefined ? 1 : lama);
        alert("Gagal mengubah status tampil momen.");
      } finally {
        this.busyId = null;
      }
    },

    splitFoto(str) {
      return str ? str.split(",") : [];
    },

    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },

    async save() {
      if (!this.editedItem.judul_momen) return alert("Sistem memerlukan Judul Momen!");

      this.loading = true;
      const formData = new FormData();
      formData.append("judul_momen", this.editedItem.judul_momen);
      formData.append("deskripsi", this.editedItem.deskripsi || "");
      formData.append("tanggal_ambil", this.editedItem.tanggal_ambil);

      this.files.forEach((file) => {
        formData.append("foto", file);
      });

      try {
        await axios.post(`${BASE_URL}/momen`, formData);
        this.fetchMomen();
        this.clearForm();
        alert("Integrasi Data Berhasil!");
      } catch (e) {
        alert("Kegagalan Transmisi Data");
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      if (confirm(`Hapus data permanen dari server: "${item.judul_momen}"?`)) {
        try {
          await axios.delete(`${BASE_URL}/momen/${item.id}`);
          this.fetchMomen();
        } catch (e) {
          alert("Sistem gagal menghapus data.");
        }
      }
    },

    clearForm() {
      this.editedItem = {
        judul_momen: "",
        deskripsi: "",
        tanggal_ambil: new Date().toISOString().substr(0, 10),
      };
      this.files = [];
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
  },
};
</script>

<style scoped>
.cyber-moments {
  background: transparent;
}

.glass-card {
  background: rgba(0, 20, 18, 0.9) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.border-primary {
  border: 1px solid #018c74 !important;
}

.cyber-text {
  letter-spacing: 2px;
  color: white !important;
  text-shadow: 0 0 8px rgba(1, 140, 116, 0.5);
}
.secondary-text {
  color: #cfa22d !important;
  letter-spacing: 1px;
}

.cyber-input-highlight >>> input {
  color: #cfa22d !important;
  font-weight: bold;
}
.cyber-search >>> .v-input__control {
  border-radius: 50px;
}

.cyber-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.cyber-card:hover {
  transform: translateY(-10px);
  border-color: #cfa22d !important;
  box-shadow: 0 0 15px rgba(207, 162, 45, 0.2) !important;
}

.cyber-title {
  letter-spacing: 0.5px;
  display: block;
  max-width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cyber-desc {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  line-height: 1.4;
  height: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.img-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, transparent 60%, rgba(0, 20, 18, 0.8));
}

.glow-chip {
  box-shadow: 0 0 5px #018c74;
  font-weight: 900;
}

.cyber-save-btn {
  color: #002d25 !important;
  font-weight: 900 !important;
  letter-spacing: 2px;
}

.glow-hover-red:hover {
  filter: drop-shadow(0 0 5px #ff5252);
  transform: scale(1.2);
}

.opacity-2 {
  opacity: 0.2;
}
.grayscale {
  filter: grayscale(1) opacity(0.5);
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}

.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

/* Status tampil / disembunyikan */
.momen-off ::v-deep .v-carousel,
.momen-off ::v-deep .v-image {
  filter: grayscale(1);
  opacity: 0.5;
}
.momen-off {
  border: 1px dashed rgba(255, 82, 82, 0.5) !important;
}
.momen-chip-active {
  background: #018c74 !important;
  color: #fff !important;
}
.momen-switch ::v-deep .v-label {
  font-size: 12.5px;
}
</style>
